import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const ReportEditIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 45 45" fill="none" {...props}>
    {/* Outer circle */}
    <path
      d="M22.5 0.75C34.5122 0.75 44.25 10.4878 44.25 22.5C44.25 34.5122 34.5122 44.25 22.5 44.25C10.4878 44.25 0.75 34.5122 0.75 22.5C0.75 10.4878 10.4878 0.75 22.5 0.75Z"
      stroke="currentColor"
      strokeOpacity="0.4"
      strokeWidth="1.5"
      fill="none"
    />

    {/* Property card */}
    <path
      d="M27.3537 18C27.3537 16.5999 27.3537 15.8998 27.0812 15.365C26.8415 14.8946 26.4591 14.5122 25.9887 14.2725C25.4539 14 24.7538 14 23.3537 14H18.0204C16.6202 14 15.9202 14 15.3854 14.2725C14.915 14.5122 14.5325 14.8946 14.2929 15.365C14.0204 15.8998 14.0204 16.5999 14.0204 18V26.6667C14.0204 28.0668 13.9142 29.2982 14.1867 29.833C14.4264 30.3034 14.7165 30.5933 15.1869 30.833C15.7217 31.1055 18.5 31 20 31"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    {/* Edit pencil */}
    <path
      d="M29.4039 23.4782L27.5413 21.6157M22.1865 28.833L23.7624 28.6579C23.9549 28.6365 24.0512 28.6258 24.1412 28.5967C24.221 28.5708 24.297 28.5343 24.367 28.4881C24.446 28.4361 24.5145 28.3676 24.6515 28.2306L30.8008 22.0813C31.3151 21.567 31.3151 20.7331 30.8008 20.2188C30.2865 19.7044 29.4526 19.7044 28.9382 20.2188L22.7889 26.3681C22.6519 26.505 22.5835 26.5735 22.5314 26.6525C22.4852 26.7225 22.4487 26.7985 22.4228 26.8783C22.3937 26.9683 22.383 27.0646 22.3616 27.2571L22.1865 28.833Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
